"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.dataCyActionOpenMenu = exports.dataCy = void 0;
var _react = require("react");
var _Stack = _interopRequireDefault(require("../Stack"));
var _TypographyListContext = _interopRequireDefault(require("./TypographyListContext"));
var _TypographyListMenu = _interopRequireDefault(require("./TypographyListMenu"));
var _clsx = _interopRequireDefault(require("clsx"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _jsxRuntime = require("react/jsx-runtime");
var _excluded = ["className", "limit", "children", "variant", "menuVariant", "align", "color", "unitsLabel", "disableTooltip", "PaperProps", "MenuProps", "spacing", "id", "type", "disableMenu", "sx", "count"];
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
var dataCy = exports.dataCy = 'TypographyList';
var dataCyActionOpenMenu = exports.dataCyActionOpenMenu = 'openMenu';
var TypographyList = function TypographyList(_ref) {
  var className = _ref.className,
    limit = _ref.limit,
    children = _ref.children,
    _ref$variant = _ref.variant,
    variant = _ref$variant === void 0 ? 'body1' : _ref$variant,
    menuVariant = _ref.menuVariant,
    align = _ref.align,
    _ref$color = _ref.color,
    color = _ref$color === void 0 ? 'initial' : _ref$color,
    unitsLabel = _ref.unitsLabel,
    _ref$disableTooltip = _ref.disableTooltip,
    disableTooltip = _ref$disableTooltip === void 0 ? false : _ref$disableTooltip,
    PaperProps = _ref.PaperProps,
    _ref$MenuProps = _ref.MenuProps,
    MenuProps = _ref$MenuProps === void 0 ? null : _ref$MenuProps,
    spacing = _ref.spacing,
    idProp = _ref.id,
    type = _ref.type,
    disableMenu = _ref.disableMenu,
    _ref$sx = _ref.sx,
    sx = _ref$sx === void 0 ? {} : _ref$sx,
    countProps = _ref.count,
    props = _objectWithoutProperties(_ref, _excluded);
  var count = Number.isFinite(countProps) ? countProps : _react.Children.count(children);
  if (limit === undefined || count <= limit) {
    return /*#__PURE__*/(0, _jsxRuntime.jsx)(_Stack["default"], _objectSpread(_objectSpread({
      "data-cy": dataCy
    }, props), {}, {
      spacing: spacing,
      className: (0, _clsx["default"])(className),
      sx: _objectSpread({
        minWidth: 0
      }, sx),
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_TypographyListContext["default"].Provider, {
        value: {
          variant: variant,
          align: align,
          color: color,
          type: type,
          disableTooltip: disableTooltip
        },
        children: children
      })
    }));
  }
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_TypographyListMenu["default"], _objectSpread(_objectSpread({
    PaperProps: PaperProps,
    menuVariant: menuVariant,
    count: count,
    unitsLabel: unitsLabel,
    disableMenu: disableMenu
  }, MenuProps), {}, {
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_TypographyListContext["default"].Provider, {
      value: {
        variant: variant,
        align: align,
        color: color
      },
      children: children
    })
  }));
};
TypographyList.propTypes = {
  align: _propTypes["default"].oneOf(['inherit', 'left', 'center', 'right', 'justify']),
  color: _propTypes["default"].oneOf(['initial', 'inherit', 'primary', 'secondary', 'textPrimary', 'textSecondary', 'error']),
  variant: _propTypes["default"].oneOf(['h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'subtitle1', 'subtitle2', 'body1', 'body2', 'caption', 'button', 'overline', 'srOnly', 'inherit'])
};
var _default = exports["default"] = TypographyList;